import React from 'react';
import { parseLoanFormat } from '../../../models/LoanFormat';
import ProductList from '../common/ProductList';
import { DISPLAY_TYPE_LIST } from '../../store/displayType/types';
import SearchCatalogueListItem from './SearchCatalogueListItem';
import { ProductSearchResponseOut } from '../../store/api';
import { LoanFormatState } from '../../store/loanFormat/state';
import { useTranslation } from 'react-i18next';
import { OrderListState } from '../../store/orderlist/state';
import { Orderlist } from '../../../models/OrderList';
import { SingleAddOptions } from '../../../models/ListContentCheckOptions';

interface ProductSuggestionProps {
    searchSuggestions: { [key: string]: ProductSearchResponseOut } | undefined;
    loanFormat: LoanFormatState;
    scopeKey: string;
    onShowAllOfLoanformat: (scopeKey: string) => void;
    readonly orderlist: OrderListState;
    readonly orderlists: ReadonlyArray<Orderlist>;
    searchTerms: string[];
    readonly onAddPrice?: (options: SingleAddOptions) => Promise<void>;
    readonly closeSuggestions: () => void;
    shopLanguage: string | undefined;
}

export const ProductSuggestion = ({
    searchSuggestions,
    loanFormat,
    scopeKey,
    searchTerms,
    onShowAllOfLoanformat,
    orderlists,
    orderlist,
    onAddPrice,
    closeSuggestions,
    shopLanguage
}: ProductSuggestionProps) => {
    const loanFormatKey = loanFormat.requestKey;
    const loanFormatName = loanFormat.name;
    const searchSuggestionHits = searchSuggestions?.[loanFormatName]?.hits;
    const { t } = useTranslation();
    const parsedLoanFormat = parseLoanFormat(loanFormatKey)?.toLowerCase();

    return (
        <>
            {searchSuggestionHits && searchSuggestionHits.length > 0 ? (
                <div>
                    <h4>
                        {t(`loanFormat.plain.${parsedLoanFormat}`, { count: 10 })}
                        <a className="more" onClick={() => onShowAllOfLoanformat(scopeKey)} data-testid="seeMore">
                            {t('components.searchSuggestions.seeAll', {
                                totalHits: searchSuggestions?.[loanFormatName].totalHits || 0,
                                label: t(`loanFormat.plain.${parsedLoanFormat}`, { count: 1 })
                            })}
                            <i className="material-icons">keyboard_arrow_right</i>
                        </a>
                    </h4>
                    <ProductList
                        closeSuggestions={closeSuggestions}
                        onAddPrice={onAddPrice}
                        products={searchSuggestionHits}
                        displayType={DISPLAY_TYPE_LIST}
                        isProductSelectable={false}
                        orderlist={orderlist}
                        orderlists={orderlists}
                        listItemComponent={SearchCatalogueListItem}
                        searchTerms={searchTerms}
                        loanFormat={loanFormatKey}
                        shopLanguage={shopLanguage}
                    />
                </div>
            ) : null}
        </>
    );
};
